import { render, staticRenderFns } from "./ProductViewerItemCard.vue?vue&type=template&id=2c1d1c6d&scoped=true&"
import script from "./ProductViewerItemCard.vue?vue&type=script&lang=js&"
export * from "./ProductViewerItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewerItemCard.vue?vue&type=style&index=0&id=2c1d1c6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d1c6d",
  null
  
)

export default component.exports